import React, { Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { PageProgressBar } from "@jsq/ds/core";
import {
  getCCToolsPath,
  getGPArenasPath,
  getSessionsPath,
  getUsersPath,
  getCCLogsPath,
  getFeatureFlagsPath,
  getToolsPath,
} from "~/common/helpers/url";
import lazyLoad from "~/common/utils/lazyLoad";

const GPArenasContainer = lazyLoad(
  () => import(/* webpackChunkName: "CCTools.GParenasContainer" */ "~/pages/CCTools/GPArenas"),
);

const SessionLogContainer = lazyLoad(
  () =>
    import(/* webpackChunkName: "CCTools.SessionLogContainer" */ "~/pages/CCTools/SessionLog"),
);

const UsersContainer = lazyLoad(
  () => import(/* webpackChunkName: "CCTools.UsersContainer" */ "~/pages/CCTools/Users"),
);

const CCLog = lazyLoad(
  () => import(/* webpackChunkName: "CCTools.CCLog" */ "~/pages/CCTools/CCLog"),
);

const DataTools = lazyLoad(
  () => import(/* webpackChunkName: "CCTools.DataTools" */ "~/pages/CCTools/DataTools"),
);

const FeatureFlags = lazyLoad(
  () => import(/* webpackChunkName: "CCTools.FeatureFlags" */ "~/pages/CCTools/FeatureFlags"),
);

const IndexRoute: React.FunctionComponent = () => (
  <Suspense fallback={<PageProgressBar />}>
    <Switch>
      <Route path={getGPArenasPath()} component={GPArenasContainer} />
      <Route path={getSessionsPath()} component={SessionLogContainer} />
      <Route path={getUsersPath()} component={UsersContainer} />
      <Route path={getCCLogsPath()} component={CCLog} />
      <Route path={getToolsPath()} component={DataTools} />
      <Route path={getFeatureFlagsPath()} component={FeatureFlags} />
      <Redirect from={getCCToolsPath()} to={getGPArenasPath()} />
    </Switch>
  </Suspense>
);

export default IndexRoute;
